import React from 'react';
import { ArrowLeft, CheckCircle, AlertTriangle, Plane, Hotel, Car, Utensils, Calendar, Download, Phone, MapPin, Clock, FileText } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
export function TripDetailPage() {
  const {
    id
  } = useParams();
  // Mock data - in a real app, fetch based on ID
  const trip = {
    title: 'Q4 Strategy Meeting',
    destination: 'San Francisco, CA',
    dates: 'Nov 12 - Nov 15, 2023',
    status: 'Confirmed',
    totalCost: '$2,003.00',
    traveler: 'Alex Morgan',
    purpose: 'Quarterly planning with executive team',
    bookingRef: 'TR-8842-SF',
    policyStatus: 'compliant'
  };
  const timeline = [{
    day: 'Day 1 — Nov 12',
    events: [{
      time: '08:00 AM',
      icon: Plane,
      color: 'bg-blue-100 text-blue-600',
      title: 'Flight UA 4521',
      details: 'JFK → SFO • Economy • Seat 12A',
      cost: '$450'
    }, {
      time: '02:00 PM',
      icon: Hotel,
      color: 'bg-purple-100 text-purple-600',
      title: 'Check-in at Marriott Union Square',
      details: 'Room 1204 • 3 Nights',
      cost: '$280/night'
    }, {
      time: '06:00 PM',
      icon: Car,
      color: 'bg-amber-100 text-amber-600',
      title: 'Ground Transport',
      details: 'Uber to dinner venue',
      cost: '$24'
    }]
  }, {
    day: 'Day 2 — Nov 13',
    events: [{
      time: '09:00 AM',
      icon: Calendar,
      color: 'bg-slate-100 text-slate-600',
      title: 'Conference Registration',
      details: 'Moscone Center',
      cost: null
    }, {
      time: '12:00 PM',
      icon: Utensils,
      color: 'bg-emerald-100 text-emerald-600',
      title: 'Lunch Meeting',
      details: 'Client: TechCorp',
      cost: '$65'
    }]
  }, {
    day: 'Day 3 — Nov 14',
    events: [{
      time: '09:00 AM',
      icon: Calendar,
      color: 'bg-slate-100 text-slate-600',
      title: 'Workshop Sessions',
      details: 'Strategy & Planning',
      cost: null
    }, {
      time: '07:00 PM',
      icon: Utensils,
      color: 'bg-emerald-100 text-emerald-600',
      title: 'Team Dinner',
      details: 'The Stinking Rose',
      cost: '$120'
    }]
  }, {
    day: 'Day 4 — Nov 15',
    events: [{
      time: '10:00 AM',
      icon: Hotel,
      color: 'bg-purple-100 text-purple-600',
      title: 'Check-out',
      details: 'Marriott Union Square',
      cost: null
    }, {
      time: '02:00 PM',
      icon: Plane,
      color: 'bg-blue-100 text-blue-600',
      title: 'Flight UA 4522',
      details: 'SFO → JFK • Economy • Seat 14C',
      cost: '$480'
    }]
  }];
  return <div className="space-y-6" data-id="element-1539">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1540">
        <div className="flex items-center gap-4" data-id="element-1541">
          <Link to="/trips" className="p-2 rounded-full hover:bg-slate-100 text-slate-500" data-id="element-1542">
            <ArrowLeft className="h-5 w-5" data-id="element-1543" />
          </Link>
          <div data-id="element-1544">
            <div className="flex items-center gap-3" data-id="element-1545">
              <h2 className="text-2xl font-bold text-slate-800" data-id="element-1546">
                {trip.title}
              </h2>
              <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 flex items-center gap-1" data-id="element-1547">
                <CheckCircle className="h-3 w-3" data-id="element-1548" /> {trip.status}
              </span>
            </div>
            <p className="text-slate-500 text-sm mt-1" data-id="element-1549">
              Ref: {trip.bookingRef}
            </p>
          </div>
        </div>
        <div className="text-right" data-id="element-1550">
          <p className="text-sm text-slate-500" data-id="element-1551">Total Cost</p>
          <p className="text-2xl font-bold text-slate-900" data-id="element-1552">{trip.totalCost}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1553">
        {/* Main Content - Itinerary */}
        <div className="lg:col-span-2 space-y-6" data-id="element-1554">
          {/* Overview Card */}
          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-1555">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1556">
              <div className="space-y-4" data-id="element-1557">
                <div className="flex items-start gap-3" data-id="element-1558">
                  <MapPin className="h-5 w-5 text-slate-400 mt-0.5" data-id="element-1559" />
                  <div data-id="element-1560">
                    <p className="text-sm font-medium text-slate-500" data-id="element-1561">
                      Destination
                    </p>
                    <p className="font-semibold text-slate-900" data-id="element-1562">
                      {trip.destination}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1563">
                  <Calendar className="h-5 w-5 text-slate-400 mt-0.5" data-id="element-1564" />
                  <div data-id="element-1565">
                    <p className="text-sm font-medium text-slate-500" data-id="element-1566">Dates</p>
                    <p className="font-semibold text-slate-900" data-id="element-1567">{trip.dates}</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1568">
                <div className="flex items-start gap-3" data-id="element-1569">
                  <FileText className="h-5 w-5 text-slate-400 mt-0.5" data-id="element-1570" />
                  <div data-id="element-1571">
                    <p className="text-sm font-medium text-slate-500" data-id="element-1572">
                      Purpose
                    </p>
                    <p className="font-semibold text-slate-900" data-id="element-1573">
                      {trip.purpose}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1574">
                  <CheckCircle className="h-5 w-5 text-emerald-500 mt-0.5" data-id="element-1575" />
                  <div data-id="element-1576">
                    <p className="text-sm font-medium text-slate-500" data-id="element-1577">
                      Policy Status
                    </p>
                    <p className="font-semibold text-emerald-700" data-id="element-1578">Compliant</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Timeline */}
          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-1579">
            <h3 className="font-bold text-lg text-slate-800 mb-6" data-id="element-1580">Itinerary</h3>
            <div className="space-y-8" data-id="element-1581">
              {timeline.map((day, dayIdx) => <div key={dayIdx} className="relative" data-id="element-1582">
                  <div className="sticky top-0 bg-white z-10 py-2 mb-4 border-b border-slate-100" data-id="element-1583">
                    <h4 className="font-semibold text-slate-900" data-id="element-1584">{day.day}</h4>
                  </div>
                  <div className="ml-4 space-y-8 border-l-2 border-slate-100 pl-8 pb-4" data-id="element-1585">
                    {day.events.map((event, idx) => <div key={idx} className="relative" data-id="element-1586">
                        <div className={`absolute -left-[41px] top-0 h-8 w-8 rounded-full border-4 border-white flex items-center justify-center ${event.color}`} data-id="element-1587">
                          <event.icon className="h-4 w-4" data-id="element-1588" />
                        </div>
                        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-2" data-id="element-1589">
                          <div data-id="element-1590">
                            <p className="text-xs font-medium text-slate-500 mb-0.5" data-id="element-1591">
                              {event.time}
                            </p>
                            <h5 className="font-semibold text-slate-900" data-id="element-1592">
                              {event.title}
                            </h5>
                            <p className="text-sm text-slate-600" data-id="element-1593">
                              {event.details}
                            </p>
                          </div>
                          {event.cost && <span className="text-sm font-medium text-slate-900 bg-slate-50 px-2 py-1 rounded" data-id="element-1594">
                              {event.cost}
                            </span>}
                        </div>
                      </div>)}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-6" data-id="element-1595">
          {/* Cost Breakdown */}
          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-1596">
            <h3 className="font-bold text-slate-800 mb-4" data-id="element-1597">Cost Breakdown</h3>
            <div className="space-y-3" data-id="element-1598">
              <div className="flex justify-between text-sm" data-id="element-1599">
                <span className="text-slate-600" data-id="element-1600">Flights</span>
                <span className="font-medium text-slate-900" data-id="element-1601">$930.00</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1602">
                <span className="text-slate-600" data-id="element-1603">Hotel</span>
                <span className="font-medium text-slate-900" data-id="element-1604">$840.00</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1605">
                <span className="text-slate-600" data-id="element-1606">Ground Transport</span>
                <span className="font-medium text-slate-900" data-id="element-1607">$48.00</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1608">
                <span className="text-slate-600" data-id="element-1609">Meals</span>
                <span className="font-medium text-slate-900" data-id="element-1610">$185.00</span>
              </div>
              <div className="border-t border-slate-100 pt-3 flex justify-between font-bold" data-id="element-1611">
                <span className="text-slate-900" data-id="element-1612">Total</span>
                <span className="text-blue-600" data-id="element-1613">$2,003.00</span>
              </div>
            </div>
          </div>

          {/* Documents */}
          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-1614">
            <h3 className="font-bold text-slate-800 mb-4" data-id="element-1615">Documents</h3>
            <div className="space-y-3" data-id="element-1616">
              <button className="w-full flex items-center justify-between p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors group" data-id="element-1617">
                <div className="flex items-center gap-3" data-id="element-1618">
                  <FileText className="h-5 w-5 text-slate-400 group-hover:text-blue-500" data-id="element-1619" />
                  <span className="text-sm font-medium text-slate-700" data-id="element-1620">
                    E-Ticket.pdf
                  </span>
                </div>
                <Download className="h-4 w-4 text-slate-400" data-id="element-1621" />
              </button>
              <button className="w-full flex items-center justify-between p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors group" data-id="element-1622">
                <div className="flex items-center gap-3" data-id="element-1623">
                  <FileText className="h-5 w-5 text-slate-400 group-hover:text-blue-500" data-id="element-1624" />
                  <span className="text-sm font-medium text-slate-700" data-id="element-1625">
                    Hotel_Conf.pdf
                  </span>
                </div>
                <Download className="h-4 w-4 text-slate-400" data-id="element-1626" />
              </button>
              <button className="w-full flex items-center justify-between p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors group" data-id="element-1627">
                <div className="flex items-center gap-3" data-id="element-1628">
                  <FileText className="h-5 w-5 text-slate-400 group-hover:text-blue-500" data-id="element-1629" />
                  <span className="text-sm font-medium text-slate-700" data-id="element-1630">
                    Itinerary.pdf
                  </span>
                </div>
                <Download className="h-4 w-4 text-slate-400" data-id="element-1631" />
              </button>
            </div>
          </div>

          {/* Emergency Contacts */}
          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-1632">
            <h3 className="font-bold text-slate-800 mb-4" data-id="element-1633">
              Emergency Contacts
            </h3>
            <div className="space-y-4" data-id="element-1634">
              <div className="flex items-start gap-3" data-id="element-1635">
                <div className="bg-red-50 p-2 rounded-full text-red-600" data-id="element-1636">
                  <Phone className="h-4 w-4" data-id="element-1637" />
                </div>
                <div data-id="element-1638">
                  <p className="text-sm font-bold text-slate-900" data-id="element-1639">
                    Local Emergency
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-1640">911 (USA)</p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-1641">
                <div className="bg-blue-50 p-2 rounded-full text-blue-600" data-id="element-1642">
                  <Phone className="h-4 w-4" data-id="element-1643" />
                </div>
                <div data-id="element-1644">
                  <p className="text-sm font-bold text-slate-900" data-id="element-1645">
                    Travel Desk
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-1646">+1 (800) 555-0199</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}